import catchErrors from './catchErrors'

// Desk Duel lobbies (v3). Every response is a lobby row: scores, round clock
// and players move every few seconds, so nothing here may be served from cache.
const live = { cache: { ignoreCache: true } }
const base = '/v3/newsdesk/desk-duel-lobbies'

export default {
  /** Open lobbies in this workspace plus every global lobby. */
  listLobbies(stationId) {
    return catchErrors.get(base, { params: { 'filter[station_id][]': stationId }, ...live })
  },
  createLobby({ stationId, name, isGlobal }) {
    return catchErrors.post(base, { station_id: stationId, name: name || undefined, is_global: !!isGlobal })
  },
  getLobby(lobbyId) {
    return catchErrors.get(`${base}/${lobbyId}`, live)
  },
  updateLobby(lobbyId, payload) {
    return catchErrors.patch(`${base}/${lobbyId}`, payload)
  },
  joinLobby(lobbyId) {
    return catchErrors.post(`${base}/${lobbyId}/players`, {})
  },
  /** With no team this is the heartbeat that keeps the player active. */
  updatePlayer(lobbyId, playerId, payload = {}) {
    return catchErrors.patch(`${base}/${lobbyId}/players/${playerId}`, payload)
  },
  leaveLobby(lobbyId, playerId) {
    return catchErrors.delete(`${base}/${lobbyId}/players/${playerId}`)
  },
  /** Ask for the next round. Every client asks; the server advances exactly once. */
  startRound(lobbyId, roundNumber) {
    return catchErrors.post(`${base}/${lobbyId}/rounds`, { round_number: roundNumber })
  },
  /** The caller was hit by shooterUserId. */
  reportHit(lobbyId, roundNumber, shooterUserId) {
    return catchErrors.post(`${base}/${lobbyId}/hits`, { round_number: roundNumber, shooter_user_id: shooterUserId })
  },
  /**
   * Ended rounds, newest first: this workspace's plus global ones (stationId),
   * or the ones a player played (playerUserId).
   */
  listRounds({ stationId, playerUserId, page = 1, perPage = 25 }) {
    const params = { page, per_page: perPage }
    if (stationId) params['filter[station_id][]'] = stationId
    if (playerUserId) params['filter[player_user_id]'] = playerUserId
    return catchErrors.get('/v3/newsdesk/desk-duel-rounds', { params, ...live })
  },
  /** One round with its scoreboard and hit-by-hit timeline. */
  getRound(roundId) {
    return catchErrors.get(`/v3/newsdesk/desk-duel-rounds/${roundId}`, live)
  },
  /** All-time totals for one player (the caller). */
  getPlayerStats(userId) {
    return catchErrors.get('/v3/newsdesk/desk-duel-player-stats', { params: { 'filter[user_id]': userId }, ...live })
  }
}
